import { Box, BoxProps } from '@opendoor/bricks-next';

import LazyLoad from 'components/helpers/LazyLoad';

interface ContainerProps extends BoxProps {
  children: React.ReactNode;
}

const Container = ({ children, backgroundColor, ...props }: ContainerProps) => {
  return (
    <LazyLoad>
      <Box className="lp-section" backgroundColor={backgroundColor}>
        <Box
          display="block"
          maxWidth={1440}
          paddingHorizontal="$10x"
          $largerThanSM={{ paddingHorizontal: '$20x' }}
          $largerThanMD={{ paddingHorizontal: '$32x' }}
          width="100%"
          marginHorizontal="auto"
          {...props}
        >
          {children}
        </Box>
      </Box>
    </LazyLoad>
  );
};

const NetProceedsCalculatorContainer = ({ children, ...props }: ContainerProps) => (
  <Box
    display="block"
    maxWidth={1440}
    paddingHorizontal="$10x"
    $largerThanSM={{ paddingHorizontal: '$20x' }}
    $largerThanMD={{ paddingHorizontal: '$32x' }}
    width="100%"
    marginHorizontal="auto"
    {...props}
  >
    {children}
  </Box>
);

const LandingPageSectionContainer = ({ children, ...props }: ContainerProps) => {
  return (
    <LazyLoad>
      <Box
        marginTop="$16x"
        display="block"
        maxWidth={1440}
        paddingHorizontal="$10x"
        $largerThanSM={{ paddingHorizontal: '$20x' }}
        $largerThanMD={{ paddingHorizontal: '$32x' }}
        width="100%"
        marginHorizontal="auto"
        {...props}
      >
        {children}
      </Box>
    </LazyLoad>
  );
};

export { LandingPageSectionContainer, NetProceedsCalculatorContainer };

export default Container;
